import * as Types from '../../../__generated__/schema';

import { RuleDetails } from '../../graphql/fragments/RuleDetails.generated';
import { PolicyDetails } from '../../graphql/fragments/PolicyDetails.generated';
import { CorrelationRule } from '../../graphql/fragments/CorrelationRule.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDetectionVariables = Types.Exact<{
  input: Types.GetDetectionInput;
}>;

export type GetDetection = {
  detection?: Types.Maybe<{ detection: CorrelationRule | PolicyDetails | RuleDetails }>;
};

export const GetDetectionDocument = gql`
  query GetDetection($input: GetDetectionInput!) {
    detection(input: $input) {
      detection {
        ... on Rule {
          ...RuleDetails
        }
        ... on Policy {
          ...PolicyDetails
        }
        ... on CorrelationRule {
          ...CorrelationRule
        }
      }
    }
  }
  ${RuleDetails}
  ${PolicyDetails}
  ${CorrelationRule}
`;

/**
 * __useGetDetection__
 *
 * To run a query within a React component, call `useGetDetection` and pass it any options that fit your needs.
 * When your component renders, `useGetDetection` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDetection({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDetection(
  baseOptions: Apollo.QueryHookOptions<GetDetection, GetDetectionVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDetection, GetDetectionVariables>(GetDetectionDocument, options);
}
export function useGetDetectionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetDetection, GetDetectionVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetDetection, GetDetectionVariables>(GetDetectionDocument, options);
}
export function useGetDetectionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetDetection, GetDetectionVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetDetection, GetDetectionVariables>(
    GetDetectionDocument,
    options,
  );
}
export type GetDetectionHookResult = ReturnType<typeof useGetDetection>;
export type GetDetectionLazyQueryHookResult = ReturnType<typeof useGetDetectionLazyQuery>;
export type GetDetectionSuspenseQueryHookResult = ReturnType<typeof useGetDetectionSuspenseQuery>;
export type GetDetectionQueryResult = Apollo.QueryResult<GetDetection, GetDetectionVariables>;
export function mockGetDetection({
  data,
  variables,
  errors,
}: {
  data: GetDetection;
  variables?: GetDetectionVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetDetectionDocument, variables },
    result: { data, errors },
  };
}
